export enum PaymentMethodCode {
  CSH = 'CSH',
  CRD = 'CRD',
  BNK = 'BNK',
}

export interface PaymentMethodInterface {
  id: string
  name: string
  l10n_name_key: string
  code: PaymentMethodCode
  created_at: string
  updated_at: string
}

export interface PaymentMethodArenaPayload {
  payment_method_id: string
}
